import { Component, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { SharedService } from '@shared/services/shared.service';
import { PaymentService } from 'app/components/payments/service/payment.service';

@Component({
  selector: 'app-pay-online-success',
  templateUrl: './pay-online-success.component.html'
})

export class PayOnlineSuccessComponent implements OnInit {

  public processing: boolean = false;
  public isValid: boolean = true;
  public token: string = '';

  constructor(public paymentService: PaymentService,
              public sharedService: SharedService,
              private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params.token;
    });
    this.processSuccess();
  }

  processSuccess() {
    if(this.token != undefined && this.token != null && this.token.length > 0) {
      this.processing = true;
      this.paymentService.updatePaymentSuccess(this.token).subscribe({
        complete: () => this.processing = false,
        error: e => {
          this.processing = false;
          console.log(e.message);
          this.sharedService.toastr.error(e.message);
        }
      });
    }
  }
}


